import React from "react";
import LayoutComponent from "components/LayoutComponent";
import Contact from "./Contact";

function action() {
  return {
    chunks: ["contact"],
    title: "Contact: Play Jigsaw Puzzle Games Online for Free",
    pathname: "/contact",
    component: (
      <LayoutComponent>
        <Contact />
      </LayoutComponent>
    )
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/contact/index.js